document.addEventListener('DOMContentLoaded', function() {
    const isOS = AFRAME.utils.device.isIOS() || AFRAME.utils.device.isAppleVisionPro()
    const scene = document.querySelector('a-scene');
    console.log('DOMContentLoaded: isOS=', isOS, 'scene=', scene)
    if (isOS && scene) {
        scene.setAttribute("xr-mode-ui", {
            XRMode: "vr",
            enterVRButton: "#enter-ar-button",
            enterARButton: "",
            enterAREnabled: false
        });
        
        // Disable post-processing when entering VR on iOS/AVP to prevent black screen
        scene.addEventListener('enter-vr', function () {
            scene.removeAttribute('bloom');
            scene.removeAttribute('renderer-tweaks');
        });
        
        // Restore post-processing when exiting VR
        scene.addEventListener('exit-vr', function () {
            scene.setAttribute('bloom', 'enabled: true; threshold: 1; strength: 0.2; radius: 0.1;');
            scene.setAttribute('renderer-tweaks', 'pixelRatio: 2;');
        });
    }
});